import { Button } from '@mui/material';
import { useEffect, useContext } from 'react';
import './Darkmode.css';
import { ThemeContext } from './ThemeProvider';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

function Darkmode() {
    const { isLightMode, handleDarkmode } = useContext(ThemeContext);

    useEffect(() => {
    }, [isLightMode]);

    return (
        <div className='darkmode'>
            <Button onClick={handleDarkmode}>
                {isLightMode ? <LightModeIcon sx={{color:'#000'}}  /> : <DarkModeIcon sx={{color:'#fff'}} />}
            </Button>
        </div>
    );
}

export default Darkmode;
